import { SoftwareStatsRoutingModule } from './software.stats.routing.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedAppModule } from '../app.module.shared';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// ASSET STATS COMPONENTS
import { AssetStatsComponent } from './asset.stats/asset.stats.component';
import { ObjectStatsComponent } from './asset.stats/components/object.stats/object.stats.component';
import { MaterialStatsComponent } from './asset.stats/components/material.stats/material.stats.component';
import { SearchStatsComponent } from './asset.stats/components/search.stats/search.stats.component';

// VENDOR STATS COMPONENTS
import { VendorStatsComponent } from './vendor.stats/vendor.stats.component';

// GUI STATS COMPONENTS
import { GuiStatsComponent } from './gui.stats/gui.stats.component';

@NgModule({
    declarations: [
        // NotesCreateComponent
        AssetStatsComponent,
        ObjectStatsComponent,
        MaterialStatsComponent,
        SearchStatsComponent,
        VendorStatsComponent,
        GuiStatsComponent,
    ],
    imports: [
        CommonModule,
        SharedAppModule,
        ReactiveFormsModule,
        FormsModule,
        SoftwareStatsRoutingModule,
    ],
    entryComponents: [

    ]
})
export class SoftwareStatsModule { }
